<template>
  <div class="component duration">
    <span v-if="hours">{{ hours }}{{ $t('general.label.hour-short') }}</span>
    <span v-if="minutes">&nbsp;{{ minutes }}{{ $t('general.label.minute-short') }}</span>
  </div>
</template>

<script>
export default {
  props: ['hours', 'minutes']
}
</script>

<style lang="scss">
.component.duration {
  display: inline-block;
  margin-bottom: 0;
}
</style>